export default {"src":"/_next/static/media/TMUS.3a1792f5.svg","height":18,"width":18};